import { sleep } from './time';

// Constant to determine if the container should be appended directly to the body
// This is used to expose specific functions globally by making the container available in the DOM
const EXPOSE_FUNCTIONS_SELECTOR = 'expose-functions';

export async function createEmebeddedContainerWrapper({
  id,
  selector,
  position,
  retryContainerCreation,
  csvUploadFormat,
}) {
  if (!selector) {
    return false;
  }
  const counter = retryContainerCreation ? 10 : 1;
  for (let i = 0; i < counter; i += 1) {
    const created = createEmebeddedContainer({ id, selector, position, csvUploadFormat });
    if (created) {
      return true;
    }
    await sleep(200);
  }
  return false;
}

export function createEmebeddedContainer({ id, selector, position, csvUploadFormat }) {
  const element = document.getElementById(id);
  if (element) {
    return true;
  }
  const elem = document.createElement('div');
  elem.style.margin = 'auto 0';
  elem.setAttribute('id', id);

  if (!selector) {
    return false;
  }

  // If the selector matches EXPOSE_FUNCTIONS_SELECTOR, append the container to body
  // This ensures that specific global functions can be accessed from anywhere in the document
  if (selector === EXPOSE_FUNCTIONS_SELECTOR) {
    appendToBody(elem);
    return true;
  }

  // if format is banner, don't trigger the fallback when app-block isn't added
  if (csvUploadFormat === 'banner') {
    return true;
  }
  // get the reference node by selector
  let referenceNode = document.querySelector(selector);
  if (!referenceNode) {
    return false;
  }

  // fallback for reference node height 0
  if (referenceNode.offsetHeight <= 0) {
    referenceNode = null;
    const nodes = document.querySelectorAll(selector);
    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];
      if (node.offsetHeight > 0) {
        referenceNode = node;
        break;
      }
    }
  }

  if (!referenceNode) {
    return false;
  }

  if (position === 'before') {
    createElementBefore(referenceNode, elem);
  } else {
    createElementAfter(referenceNode, elem);
  }
  return true;
}

// Function to append an element to the body while keeping it hidden initially
// This is particularly useful when exposing functions that do not require a visible UI element
function appendToBody(element) {
  element.style.position = 'absolute';
  element.style.visibility = 'hidden';
  document.body.appendChild(element);
}

export function createElementAfter(element, newElement) {
  element.parentNode.insertBefore(newElement, element.nextSibling);
}

export function createElementBefore(element, newElement) {
  element.parentNode.insertBefore(newElement, element);
}
